import AccountDepositOverdraftInterestSettings from "@/models/Accounts/DepositAccounts/Settings/AccountDepositOverdraftInterestSettings";
import InterestRateType from "@/models/Products/InterestRateType";
import BaseUpdateAccountSettings from "@/models/Accounts/Shared/BaseUpdateAccountSettings";
import Amount from "@/models/Shared/Amount";

export default class UpdateAccountDepositOverdraftInterestSettingsRequest extends BaseUpdateAccountSettings {
    enabled: boolean = false;
    interestBearingThreshold: Amount = new Amount();
    rateType: InterestRateType = InterestRateType.Fixed;
    rateValue: number = 0;
    rateSourceId: string;

    public constructor(settings: AccountDepositOverdraftInterestSettings, updatedAt: Date) {
        super(updatedAt);
        if (settings !== null) {
            // Create a copy of settings to de-reference the original settings and avoid changing them here
            const settingsCopy = JSON.parse(JSON.stringify(settings));
            this.enabled = settingsCopy.enabled;
            this.interestBearingThreshold = settingsCopy.interestBearingThreshold;
            this.rateType = settingsCopy.rateType;
            this.rateValue = settingsCopy.rateValue;
            this.rateValue = +this.rateValue;
            this.rateSourceId = settingsCopy.rateSourceId;
        }
    }
}